import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { CampaignMilestone, DateRange } from '../interfaces';
import { CampaignSearchParams } from '../interfaces/workspace-search-params.interface';
import { ApiRequestOptions, ApiService } from './api.service';
import { CryptoService } from './crypto.service';
import { EmitterService } from './emitter.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { currentAppToken } from '../auth/app-token';

@Injectable({
  providedIn: 'root',
})
export class ProjectV2ServiceService implements OnDestroy {
  baseUrl: string;
  timelineId: string;
  timelineData: any;
  isFullView: boolean;
  driveCoordinatorTimeline: any = {
    timelines: null,
    project: null,
  };
  driveCoordinatorMilestone: any;
  ngUnsubscribe = new Subject();
  requestOptions: ApiRequestOptions = { redirectOnForbidden: true };

  private readonly campaigndriveTimelineId: string;
  timelineDataEmmit: EventEmitter<any> = new EventEmitter<any>();

  private readonly formData = {
    general: {},
    timelineCriteria: {},
  };
  //TO_COME, IN_PROGRESS,

  colors = {
    CAMPAIGN: '#000000',
    PRODUCT: '#1E43A1',
    MAGELLAN: '#1E43A1',
    'COLLECTOR / PRODUCT': '#086289',
    GIFT: '#923065',
    SET: '#502B9D',
  };

  statusColor = {
    TO_COME: '#FFFFFF',
    IN_PROGRESS: '#FFFFFF',
    UPCOMING_EXPIRY: '#FF9A3D',
    COMPLETED: '#55C982',
    DELAYED: '#F86868',
    SUPER_DELAYED: '#F86868',
  };

  milestoneTypes: any[] = [
    {
      value: 'all',
      label: 'All Campaign',
    },
    {
      value: 'campaign',
      label: 'Campaign',
    },
    {
      value: 'product',
      label: 'Product',
    },
    {
      value: 'magellan',
      label: 'Magellan',
    },
    {
      value: 'gift',
      label: 'Gift',
    },
    {
      value: 'set',
      label: 'Set',
    },
  ];

  private readonly dropdownValue: Subject<any> = new Subject();

  public getDropdownValue(): Observable<any> {
    return this.dropdownValue.asObservable();
  }

  public setDropdownValue(value: any): void {
    this.dropdownValue.next(value);
  }
  private readonly timlineSource = new BehaviorSubject({});
  currentTimelineData = this.timlineSource.asObservable();

  private readonly formDataUpdated = new BehaviorSubject({});
  formDataUpdated$ = this.formDataUpdated.asObservable();

  private readonly timlineFullView = new BehaviorSubject(true);
  currentVisibility = this.timlineFullView.asObservable();

  private readonly driveSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private readonly selectedCampaignDrive = new BehaviorSubject({});
  campaignDriveMilestoneData = this.selectedCampaignDrive.asObservable();

  //timeline opacity
  private readonly isHiddenTimeline = new BehaviorSubject(true);
  hideTimeline = this.isHiddenTimeline.asObservable();

  //share workspace id
  workspaceIdSubject: Subject<string> = new Subject<string>();
  workspaceId: Observable<string> = this.workspaceIdSubject.asObservable();

  // hide recape header
  recapHiddenHeader: Subject<boolean> = new Subject<boolean>();
  isHeaderHidden: Observable<boolean> = this.recapHiddenHeader.asObservable();

  // update selected milestone color
  selectedDCmilestone = new BehaviorSubject({ name: '', color: '', items: [], isDCtimeline: false });
  milestoneColorUpdated = this.selectedDCmilestone.asObservable();

  // public selectedDCmilestone: Subject<any> = new Subject<any>({time,tit,false});
  // public milestoneColorUpdated: Observable<any> = this.selectedDCmilestone.asObservable();
  timeline = new BehaviorSubject({});
  updatedStatusTimeline = this.timeline.asObservable();

  // updated milestone
  selectedMilestone = new BehaviorSubject({});
  updateMilestone = this.selectedMilestone.asObservable();

  //set selected workspace name from general component for
  workspaceName: string;

  constructor(
    private readonly apiService: ApiService,
    private readonly httpClient: HttpClient,
    private readonly cryptoService: CryptoService,
    private readonly router: Router
  ) {
    this.baseUrl = environment.api.baseUrl;
  }
  authUser: any;
  notificationTimelineData = {
    data: {},
  };
  ngOnDestroy(): void {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  updatedTimeline() {
    this.updatedStatusTimeline.subscribe((timeline) => {
      this.handleTimelineData(timeline);
    });
  }

  updatedMilestone(milestone: any) {
    this.selectedMilestone.next(milestone);
  }

  getDriveCoordinatorTimeline() {
    return this.driveCoordinatorTimeline;
  }

  sendData(data: string, madDate: any) {
    this.timlineSource.next({ data, madDate });
  }

  getCampaignDriveTimeline(data: any) {
    this.selectedCampaignDrive.next(data);
  }

  toggleVisibility(isVisible: boolean) {
    this.timlineFullView.next(isVisible);
  }

  //store form data
  updateFormData(generalFormData, criteriaFormData) {
    this.formData.general = generalFormData;
    this.formData.timelineCriteria = criteriaFormData;
    this.formDataUpdated.next(this.formData);
    EmitterService.get('DRIVE_CAMPAIGN:FORM_UPDATED').emit(this.formData);
  }

  //return form data
  getFormData() {
    return this.formData;
  }

  setOpacity(opacity: boolean) {
    this.isHiddenTimeline.next(opacity);
  }

  private adjustMilestoneName(milestone) {
    if (milestone.name == 'PREMIUM COFFRET') {
      milestone.name = 'PREMIUM SET';
    } else if (milestone.name == 'STANDARD COFFRET') {
      milestone.name = 'STANDARD SET';
    } else if (milestone.name == 'MARKETING BOOK') {
      milestone.name = 'MARKETING BOOK GIFT';
    } else if (milestone.name == 'DEFINITIVE ARTWORKS') {
      milestone.name = 'DEFINITIVE ARTWORKS GIFT';
    } else if (milestone.name == 'GO BRIEF DESIGN TO COST') {
      milestone.name = 'DESIGN TO COST GIFT';
    } else if (milestone.name == 'GO BRIEF FIGE') {
      milestone.name = 'FIXED DESIGN GIFT';
    }
  }

  handleTimeLineDataSync(timeline: CampaignMilestone[], isHallmark: boolean, driveCampaignId?: string) {
    if (!timeline) {
      return;
    }
    timeline.forEach((elem) => {
      // remove null mad items in subitems
      if (!elem.items) {
        return;
      }

      elem.items.forEach((milestone) => {
        if (milestone.items && milestone.items.length) {
          milestone.items = milestone.items.filter((subItem) => subItem.name && subItem.mad && subItem.driveDate);
        }
      });

      // remove null mad
      elem.items = elem.items.filter((milestone) => {
        if (milestone.name && milestone.items && milestone.items.length) {
          return true;
        } else {
          if (milestone.name && milestone.mad && milestone.driveDate) {
            return true;
          } else {
            return false;
          }
        }
      });

      // handle showblock
      if (elem.items.length > 0) {
        elem['showBlock'] = true;
        elem['showToggleIcons'] = true;
        elem['removeBlock'] = false;
      } else {
        elem['showBlock'] = false;
        elem['showToggleIcons'] = true;
        elem['removeBlock'] = true;
      }

      // set block color
      let color = '#FFFFFF';
      switch (elem.name) {
        case 'PRODUCT':
          color = this.colors.PRODUCT;
          (elem as any).showToggleIcons = true;
          (elem as any).showProductionToggleIcons = false;
          if (elem.items) {
            elem.items.forEach((element) => {
              //this.randomValues(element);
              element['showMilestone'] = false;
              element['showTasks'] = false;
              element['showProjects'] = false;
              element['showProjectsBlock'] = false;
              element['showProjectStage'] = false;
              element['driveCampaignId'] = driveCampaignId;
              element['isNegociated'] = false;
              element.blockColor = this.colors.PRODUCT;
              if (element.items && element.items.length) {
                this.randomValues(element);
                element.items.forEach((subitem) => {
                  subitem.blockColor = this.colors.PRODUCT;
                });
              }
            });
          }
          break;
        case 'CAMPAIGN':
          color = this.colors.CAMPAIGN;
          (elem as any).showToggleIcons = false;
          (elem as any).showProductionToggleIcons = false;
          if (elem.items) {
            elem.items.forEach((element, i) => {
              //this.randomValues(element);
              element['showMilestone'] = false;
              element['showTasks'] = false;
              element['showProjects'] = false;
              element['showProjectsBlock'] = false;
              element['showProjectStage'] = false;
              element['driveCampaignId'] = driveCampaignId;
              element['isNegociated'] = false;
              element.blockColor = this.colors.CAMPAIGN;
              if (element.items && element.items.length) {
                element.items.forEach((subitem, j) => {
                  this.randomValues(element);
                  const opacity = 0.2 * (j + 1);
                  subitem.blockName = element.name;
                  subitem.blockColor = this.colors.CAMPAIGN;
                  // subitem.subItemBlockColor = `linear-gradient(0deg, rgba(255, 255, 255, ${opacity}), rgba(255, 255, 255, ${opacity})), ${this.colors.CAMPAIGN}`;
                  (subitem as any).subItemBlockColor = '#EEF2F9';
                  (subitem as any).subItemTextColor = '#000000';
                });
              }
            });
          }
          break;
        case 'MAGELLAN':
          color = this.colors.MAGELLAN;
          (elem as any).showToggleIcons = true;
          (elem as any).showProductionToggleIcons = false;
          if (elem.items) {
            elem.items.forEach((element) => {
              //this.randomValues(element);
              element['showMilestone'] = false;
              element['showTasks'] = false;
              element['showProjects'] = false;
              element['showProjectsBlock'] = false;
              element['showProjectStage'] = false;
              element['driveCampaignId'] = driveCampaignId;
              element['isNegociated'] = false;
              element.blockColor = this.colors.MAGELLAN;
              if (element.items && element.items.length) {
                element.items.forEach((subitem) => {
                  this.randomValues(element);
                  subitem.blockColor = this.colors.MAGELLAN;
                });
              }
            });
          }
          break;
        case 'COLLECTOR / PRODUCT':
          color = this.colors['COLLECTOR / PRODUCT'];
          (elem as any).showToggleIcons = true;
          (elem as any).showProductionToggleIcons = false;
          if (elem.items) {
            //this.randomValues(elem);
            elem.items.forEach((element) => {
              this.randomValues(element);
              element['showMilestone'] = false;
              element['showTasks'] = false;
              element['showProjects'] = false;
              element['showProjectsBlock'] = false;
              element['showProjectStage'] = false;
              element['driveCampaignId'] = driveCampaignId;
              element['isNegociated'] = false;
              element.blockColor = this.colors['COLLECTOR / PRODUCT'];
              if (element.items && element.items.length) {
                element.items.forEach((subitem) => {
                  this.randomValues(element);
                  subitem.blockColor = this.colors['COLLECTOR / PRODUCT'];
                });
              }
            });
          }
          break;
        case 'GIFT':
          color = this.colors.GIFT;
          (elem as any).showToggleIcons = true;
          (elem as any).showProductionToggleIcons = false;
          if (elem.items) {
            //this.randomValues(elem);
            elem.items.forEach((element) => {
              element['showMilestone'] = false;
              element['showTasks'] = false;
              element['showProjects'] = false;
              element['showProjectsBlock'] = false;
              element['showProjectStage'] = false;
              element['driveCampaignId'] = driveCampaignId;
              element['isNegociated'] = false;
              this.randomValues(element);
              element.blockColor = this.colors.GIFT;
              if (isHallmark) {
                this.adjustMilestoneName(element);
              }
              if (element.items && element.items.length) {
                element.items.forEach((subitem) => {
                  this.randomValues(element);
                  subitem.blockColor = this.colors.GIFT;
                  if (isHallmark) {
                    this.adjustMilestoneName(subitem);
                  }
                });
              }
            });
          }
          break;
        case 'SET':
          color = this.colors.SET;
          (elem as any).showToggleIcons = true;
          (elem as any).showProductionToggleIcons = false;
          if (elem.items) {
            this.randomValues(elem);
            elem.items.forEach((element, i) => {
              element['showMilestone'] = false;
              element['showTasks'] = false;
              element['showProjects'] = false;
              element['showProjectsBlock'] = false;
              element['showProjectStage'] = false;
              element['driveCampaignId'] = driveCampaignId;
              element['isNegociated'] = false;
              this.randomValues(element);
              element.blockColor = this.colors.SET;
              if (element.items && element.items.length) {
                element.items.forEach((subitem) => {
                  this.randomValues(element);
                  const opacity = 0.2 * (i + 1);
                  subitem.blockName = element.name;
                  subitem.blockColor = this.colors.SET;
                  (subitem as any).subItemBlockColor =
                    `linear-gradient(0deg, rgba(255, 255, 255, ${opacity}), rgba(255, 255, 255, ${opacity})), ${this.colors.SET}`;
                  (subitem as any).subItemTextColor = '#FFFFFF';
                  if (isHallmark) {
                    this.adjustMilestoneName(subitem);
                  }
                });
              }
            });
          }
          break;
        default:
          break;
      }

      // add color keys
      elem['blockColor'] = color;
      elem['milestoneFlagColor'] = '#FFFFFF';

      // pin block key
      elem['pinBlock'] = false;
    });
  }

  // destructue timeline data and add custom fields
  //TODO: remove async signature
  async handleTimelineData(timeline, isHallmark?) {
    const driveCampaignId = timeline.id;
    if (timeline) {
      // if ( timeline.timelines.timelines) {
      //   if (typeof timeline.timelines.timelines == "string") {
      //     timeline = JSON.parse(timeline.timelines);
      //   } else {
      //     timeline = timeline.timelines.timelines
      //   }

      // } else {
      // }
      timeline = JSON.parse(timeline.timelines);
      this.handleTimeLineDataSync(timeline, isHallmark, driveCampaignId);
      // return new Promise<any>((resolve, reject) => {
      //   resolve(timeline);
      // });

      return timeline;
    }
  }

  // filter milestone array from timeline
  async filterMilestonesFromTimeline(timelines: any) {
    const milestones = [];
    if (timelines) {
      await timelines.forEach((timeline) => {
        if (timeline.items) {
          timeline.items.forEach((elem, index) => {
            // add items
            if (elem.name && elem.mad && elem.driveDate) {
              milestones.push(elem);
            }
            if (elem.items) {
              elem.items.forEach((subItem) => {
                // add sub items
                if (subItem.name && subItem.mad && subItem.driveDate) {
                  milestones.push(subItem);
                }
              });
            }
          });
        }
      });

      return milestones;
    }
  }

  randomValues(element) {
    // const milestoneData = [
    //   { total: 7, completed: 5 },
    //   { total: 5, completed: 1 },
    //   { total: 17, completed: 5 },
    //   { total: 16, completed: 8 },
    //   { total: 18, completed: 4 }
    // ];
    // // workSpaces.forEach((item) => {
    // // Add random driveStatus
    // const randomStatus = milestoneData[Math.floor(Math.random() * milestoneData.length)];
    // element.totalProject = randomStatus.total;
    // element.completedProject = randomStatus.completed;
    // element.totalTask = randomStatus.total;
    // element.completedTask = randomStatus.completed;
    // // });
    // return element;
  }

  async updateDriveCampaignOnly(workspaceId: string, driveCampaignId: string) {
    try {
      const drive = await this.getSingleDriveCampaign(workspaceId, driveCampaignId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise();
      const expectedMadDate = new Date(drive.expectedMad);
      const formattedExpectedMad = expectedMadDate.toISOString();

      // Extract relevant data from the drive object
      const {
        id,
        name,
        magellanNumber,
        description,
        logo,
        projectLeaders,
        cncManager,
        productName,
        expectedMad,
        priority,
        timelineCriteria,
        timelines,
        banner,
        status,
        activeProduct,
        assetListCriteria,
        assetList,
        assetListWorkspaceModelId,
      } = drive;

      // Populate generalFormData
      const generalFormData = {
        id,
        name,
        description,
        magellanNumber,
        logo, // You can update this if needed
        workspaceId,
        projectLeaders, // You can update this if needed
        cncManager,
        expectedMad: formattedExpectedMad,
        priority,
        timelineCriteria, // If criteria is a JSON string, no need to parse it,
        timelines,
        banner,
        status,
        productName,
        activeProduct,
        assetListCriteria,
        assetList,
        assetListWorkspaceModelId,
      };

      // Populate criteriaFormData (you can directly assign it, as it's already a valid object)
      const criteriaFormData = JSON.parse(timelineCriteria);

      // Call the updateFormData function
      this.updateFormData(generalFormData, criteriaFormData);

      this.timelineId = drive.id;
      EmitterService.get('DRIVE_CAMPAIGN:FORM_UPDATED').emit(drive);
    } catch (e) {}
  }

  async updateSelectedDriveCampaign(workspaceId: string, driveCampaignId: string, redirectToRecap: boolean = false) {
    try {
      const drive = await this.getSingleDriveCampaign(workspaceId, driveCampaignId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise();
      // Convert UNIX timestamp to formatted date-time string
      const expectedMadDate = new Date(drive.expectedMad);
      const formattedExpectedMad = expectedMadDate.toISOString(); // "2023-09-01T18:30:00.000Z"

      // Extract relevant data from the drive object
      const {
        id,
        name,
        magellanNumber,
        description,
        logo,
        projectLeaders,
        cncManager,
        productName,
        expectedMad,
        priority,
        timelineCriteria,
        timelines,
        banner,
        status,
        activeProduct,
        assetListCriteria,
        assetList,
        assetListWorkspaceModelId,
      } = drive;

      // Populate generalFormData
      const generalFormData = {
        id,
        name,
        description,
        magellanNumber,
        logo, // You can update this if needed
        workspaceId,
        projectLeaders, // You can update this if needed
        cncManager,
        expectedMad: formattedExpectedMad,
        priority,
        timelineCriteria, // If criteria is a JSON string, no need to parse it,
        timelines,
        banner,
        status,
        productName,
        activeProduct,
        assetListCriteria,
        assetList,
        assetListWorkspaceModelId,
      };

      // Populate criteriaFormData (you can directly assign it, as it's already a valid object)
      const criteriaFormData = JSON.parse(timelineCriteria);

      // Call the updateFormData function
      this.updateFormData(generalFormData, criteriaFormData);

      this.timelineId = drive.id;
      setTimeout(() => {
        if (redirectToRecap) {
          this.router.navigate([`workspaces/campaigndrive/${drive.workspaceId}/recap`], {
            queryParams: {
              wid: this.cryptoService.encryptString(drive.workspaceId),
              dc: this.cryptoService.encryptString(generalFormData.id),
            },
          });
        } else {
          this.router.navigate([`/workspaces/campaigndrive/${drive.workspaceId}/general`], {
            queryParams: {
              wid: this.cryptoService.encryptString(drive.workspaceId),
              dcId: this.cryptoService.encryptString(this.timelineId),
            },
          });
        }
        EmitterService.get('DRIVE_CAMPAIGN:FORM_UPDATED').emit(drive);
      }, 0);
    } catch (error) {
      console.error('Error fetching drive:', error);
    }
  }

  getDrive() {
    return this.driveSubject.asObservable();
  }

  setDrive(drive: any) {
    this.driveSubject.next(drive);
  }

  //create Timeline
  public createTimeline(data): Observable<any> {
    data.magellanNumber = Number(data.magellanNumber) || null;
    const payload = { ...data, magellanNumber: Number(data.magellanNumber) || null };
    return this.apiService.httpPost('/api/campaigns', payload, false, false, {}, this.requestOptions);
  }

  public bulkUpdateCampaignAssets(data: {
    id: string; // campaign id
    assetList: string; // asset list json string
  }): Observable<any> {
    return this.apiService.httpPost(
      '/api/campaigns/asset-list/bulk-update',
      data,
      false,
      false,
      {},
      this.requestOptions
    );
  }

  public createUpdateAssetList(campaignId: string, data: any): Observable<any> {
    return this.apiService.httpPost(
      `/api/campaigns/asset-list/campaign/${campaignId}`,
      data,
      false,
      false,
      {},
      this.requestOptions
    );
  }

  public deleteAsset(campaignId: string, assetId: string): Observable<any> {
    return this.apiService.httpDelete(
      `/api/campaigns/asset-list/campaign/${campaignId}/${assetId}`,
      null,
      this.requestOptions
    );
  }

  public deleteSubAsset(campaignId: string, assetId: string, subAssetId: string): Observable<any> {
    return this.apiService.httpDelete(
      `/api/campaigns/asset-list/campaign/${campaignId}/${assetId}/${subAssetId}`,
      null,
      this.requestOptions
    );
  }

  public bulkUpdateAssets(campaignId: string, data: any): Observable<any> {
    return this.apiService.httpPost(
      `/api/campaigns/asset-list/campaign/${campaignId}/bulk-action`,
      data,
      false,
      false,
      {},
      this.requestOptions
    );
  }

  public dragAndDropAssets(campaignId: string, fromAssetId: string, toAssetId: string): Observable<any> {
    return this.apiService.httpPut(
      `/api/campaigns/asset-list/campaign/${campaignId}/${fromAssetId}/move?toAssetId=${toAssetId}`,
      {},
      this.requestOptions
    );
  }

  public updateDateStatusMilestone(campaignId, data): Observable<any> {
    return this.apiService.httpPut(
      `/api/campaigns/timeline/milestones/${campaignId}/${data.id}`,
      data,
      this.requestOptions
    );
  }

  //get saved driveCampaigns using workspaceId
  public getDriveCampaign(
    workspaceId?: string,
    archived: boolean = true,
    searchParams?: CampaignSearchParams,
    dates?: any,
    pagingState?: string
  ): Observable<any> {
    const urlParams = [];
    let url: string;

    if (workspaceId) {
      url = `/api/campaigns/all/${workspaceId}`;
    } else {
      url = `/api/campaigns/all`;
    }
    if (archived || !archived) {
      urlParams.push(`isArchived=${archived}`);
    }
    if (searchParams?.activeProduct) {
      urlParams.push(`activeProduct=${searchParams.activeProduct}`);
    }
    if (searchParams?.selectedMonths?.length) {
      urlParams.push(`selectedMonths=${searchParams.selectedMonths.join(',')}`);
    }
    if (searchParams?.projectLeaders?.length) {
      urlParams.push(`projectLeaders=${encodeURIComponent(searchParams.projectLeaders.join(','))}`);
    }
    if (searchParams?.cncManagers?.length) {
      urlParams.push(`cncManagers=${encodeURIComponent(searchParams.cncManagers.join(','))}`);
    }
    if (pagingState) {
      urlParams.push(`pagingState=${encodeURIComponent(pagingState)}`);
    }
    url += '?' + urlParams.join('&');
    return this.apiService.httpGet(url, false, {}, this.requestOptions);
  }

  //get selected driveCampaign using workspaceId
  public getSingleDriveCampaign(
    workspaceId: string,
    driveCampaignId: string,
    assetListProject = false
  ): Observable<any> {
    let url = `/api/campaigns/${workspaceId}/${driveCampaignId}`;
    if (assetListProject) {
      url += '?assetListProject=true';
    }
    return this.apiService.httpGet(url, false, {}, this.requestOptions);
  }

  public downloadPPT(data): Observable<any> {
    const headers = new HttpHeaders();
    const token = currentAppToken();
    if (token) {
      headers.append('Authorization', 'Bearer ' + token);
    }
    return this.httpClient.post(this.baseUrl + '/api/power-point/generate', data, {
      headers: headers,
      responseType: 'blob',
    });
  }

  updateDriveCampaign(data) {
    return this.apiService.httpPost(`/api/campaigns`, data, false, false, {}, this.requestOptions);
  }

  updateDriveCampaignStatus(workspaceId: string, id: string, status: string): Observable<any> {
    return this.apiService.httpPost(
      '/api/campaigns/status',
      { workspaceId, id, status },
      false,
      false,
      {},
      this.requestOptions
    );
  }

  deleteDriveCampaign(workspaceId, id) {
    return this.apiService.httpDelete(`/api/campaigns/${workspaceId}/${id}`, null, this.requestOptions);
  }

  /**
   * function for calculate date for calendar filter
   * @param period it take modes like latest, week 3 month and 6 month
   * @returns end date and start date
   */
  calculateDateRange(period): DateRange {
    const endDate = new Date(); // Current date
    let startDate = new Date(); // Start date initialization

    switch (period) {
      case 'week':
        startDate.setDate(endDate.getDate() - 7);
        break;
      case '3_months':
        startDate.setMonth(endDate.getMonth() - 3);
        break;
      case '6_months':
        startDate.setMonth(endDate.getMonth() - 6);
        break;
      case 'latest':
        startDate = new Date(); // Set both startDate and endDate to the current date
        break;
      default:
        console.error("Invalid period specified. Use 'previousWeek', 'last3Months', or 'last6Months'.");
        return;
    }

    // Format the dates as YYYY-MM-DD
    // const formatDate = (date) => date.toISOString().split('T')[0];

    return {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
  }

  getMilestoneComment(milestoneId: string) {
    return this.apiService.httpGet(`/api/campaigns/timeline/milestones/comments/${milestoneId}`);
  }

  createMilestoneComment(milestoneId: string, data: any) {
    return this.apiService.httpPost(`/api/campaigns/timeline/milestones/comments/${milestoneId}`, data);
  }

  getMilestoneCommentReply(parentId: string) {
    return this.apiService.httpGet(`/api/campaigns/timeline/milestones/comments/${parentId}`);
  }

  editMilestoneComment(commentId: string, data) {
    return this.apiService.httpPut(`/api/campaigns/timeline/milestones/comments/${commentId}`, data);
  }

  deleteMilestoneComment(commentId: string) {
    return this.apiService.httpDelete(`/api/campaigns/timeline/milestones/comments/${commentId}`);
  }
}
